import React, { useEffect } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { clockImageProps } from 'src/resources/images';
import { startAuthenticationActionCreator } from 'src/state/auth/action-creators/start-authentication-action-creator';
import { useAppDispatch } from 'src/state/thunk-api';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

import { useResetState } from './hooks/use-reset-state';

export const PageSessionExpired = () => {
  const dispatch = useAppDispatch();
  const { resetState } = useResetState();

  useEffect(
    () => {
      resetState();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleLogin = () => dispatch(startAuthenticationActionCreator());

  return (
    <CommonError
      title={i18n.page.error.sessionExpired.title}
      subtitles={[i18n.page.error.sessionExpired.sessionHasExpired, i18n.page.error.sessionExpired.loginAgain]}
      image={clockImageProps}
      hideCustomerServiceText={true}
      buttonOptions={{ onClick: handleLogin, children: i18n.page.error.sessionExpired.login }}
      dataLayerErrorMessage={DataLayerEcomErrors.SESSION_EXPIRED_ERROR}
    />
  );
};
